import React, { useState, useEffect } from 'react';
import { Form, Button, Dropdown, Modal, Row, Col, Spinner } from "react-bootstrap";
import { Add, More, Trash, Edit2 } from 'iconsax-react';
import Select from "react-select";
import CampoRicerca from "../../Util/CampoRicerca";
import TabellaLista from '../../Tabella/TabellaLista';
import MyApiClient from '../../../../api-client/MyApiClient';
import nosports from "../../../../images/nosports.png";
import { sports } from '../../Util/enum';
import { useFederations } from '../../../../hooks/useFederations';

/*
FEDERAZIONI NON PASSATO DA API QUINCK
const federazioni = [
	{ value: "FIGC", label: "FIGC" },
	{ value: "ASI", label: "ASI" },
	{ value: "ASDI", label: "ASDI" },
	{ value: "FIN", label: "FIN" }
];
*/

export const FormSport = (props) => {

	const [selectedSport, setSelectedSport] = useState('');
	const [selectedFederation, setSelectedFederation] = useState([]);
	const [data_json, setDataJson] = useState(null);
	const [modalCentered, setModalCentered] = useState(false);
	const [editMode, setEditMode] = useState(false);

	// Hook per gestire le federazioni
	const { federations, loading: federationsLoading, error: federationsError, getFederationsBySport } = useFederations();

	const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);

	const [loadingShowed, setLoadingShowed] = useState(false);

	const handleSelectChange = (selectedOptions) => {
		setSelectedSport(selectedOptions.value);
		// Reset organismo quando cambia lo sport
		setSelectedFederation([]);
    };

	const handleFederationChange = (selectedOptions) => {
		setSelectedFederation(selectedOptions || []);
    };

	// Funzione per ottenere le federazioni disponibili per lo sport selezionato
	const getAvailableFederations = () => {
		if (!selectedSport || !federations.length) return [];
		
		// Federazioni che non hanno sport specifici (vanno bene per tutti)
		const universalFederations = federations.filter(fed => !fed.sports || fed.sports.length === 0);
		
		// Federazioni che hanno lo sport selezionato
		const sportSpecificFederations = federations.filter(fed => 
			fed.sports && fed.sports.length > 0 && fed.sports.includes(selectedSport.toUpperCase())
		);
		
		// Combina le due liste
		const availableFederations = [...universalFederations, ...sportSpecificFederations];
		
		// Converte in formato per react-select
		return availableFederations.map(fed => ({
			value: fed.code,
			label: `${fed.code} - ${fed.description}`
		}));
	};

	// Funzione per resettare i campi del modal
	const resetModalFields = () => {
		setSelectedSport('');
		setSelectedFederation([]);
	};

	const openEditModal = (row) => {
		setSelectedSport(row.type);
		
		// Prepopola gli organismi selezionati
		if (row.sportPromotionBody && row.sportPromotionBody.length > 0) {
			const selectedFeds = row.sportPromotionBody.map(fedCode => {
				const fed = federations.find(f => f.code === fedCode);
				return {
					value: fedCode,
					label: fed ? `${fed.code} - ${fed.description}` : fedCode
				};
			});
			setSelectedFederation(selectedFeds);
		} else {
			setSelectedFederation([]);
		}
		
		setEditMode(true);
		setModalCentered(true);
	};

	const clubNature = props.profile?.club?.clubNature;
	const showOrganismiColumn = clubNature === 'ASD' || clubNature === 'SSD';

	const data_column = [
		{
			Header: 'Sport',
			accessor: 'sport_name',
		},
		...(showOrganismiColumn ? [{
			Header: 'Organismi sportivi',
			accessor: 'sport_federazioni',
			Cell: ({ row }) => {
				const federationsList = row.original.sportPromotionBody || [];
				return federationsList.length > 0 ? federationsList.join(', ') : 'Nessuna';
			}
		}] : []),
		{
			Header: 'Azione',
			Footer: 'Azione',
			accessor: 'azione',
			Cell: ({ row }) => {
				return (
					!props.isDisabled &&
					<Dropdown drop="auto">
						<Dropdown.Toggle className="btn-primary light sharp i-false btn-action">
							<More />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item onClick={() => openEditModal(row.original)}><span className="me-2"><Edit2 size="20" /></span>Modifica</Dropdown.Item>
							<br />
							<Dropdown.Item onClick={() => deleteSports(row.original)} className="text-danger"><span className="me-2"><Trash size="20" /></span>Cancella</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				)
			},
			disableFilters: true,
		},
	];

	function updateSportsTable(club_sports) {
		const updatedDataJson = club_sports.map((sport, index) => {
			const sportType = sport.sportType;
			let sportLabel = '';
			sports.forEach(element => {
				if(element.value === sportType) {
					sportLabel = element.label;
				}
			});
			return {
				id: index + 1,
				sport_name: sportLabel,
				type: sportType,
				sportPromotionBody: sport.sportPromotionBody || []
			};
		});
		setDataJson(updatedDataJson);
	}

	useEffect(() => {
		if (props.profile && props.profile.club && props.profile.club.sports) {
            updateSportsTable(props.profile.club.sports);
        } else {
            setDataJson([]);
        }
    }, [props]);

	const deleteSports = (row) => {
		setOnContinue(() => () => continueDeleteSport(row));
		setConfirmShowed(true);
	};

	const continueDeleteSport = (row) => {
		setConfirmShowed(false);
		let removeSport = row.type;

		let sports_send = [];
		data_json.forEach(element => {
			if(element.type !== removeSport) {
				const sportToKeep = { "sportType": element.type };
				if(element.sportPromotionBody && element.sportPromotionBody.length > 0) {
					sportToKeep.sportPromotionBody = element.sportPromotionBody;
				}
				sports_send.push(sportToKeep);
			}
		});
		if (sports_send.length === 0) {
			setModalTitle("Errore durante l'operazione");
			setModalText("Non è possibile cancellare l'ultimo sport disponibile.");
			setModalShowed(true);
			return;
		}
		updateProfile(sports_send);
	}

	const addSports = (e) => {
        e.preventDefault();

		if(selectedSport==='') {
			setModalTitle("Errore durante l'operazione");
			setModalText("Lo sport deve essere valorizzato.");
			setModalShowed(true);
			return;
		}

		const clubNature = props.profile?.club?.clubNature;
		if ((clubNature === 'ASD' || clubNature === 'SSD') && (!selectedFederation || selectedFederation.length === 0)) {
			setModalTitle("Errore durante l'operazione");
			setModalText("Per le strutture ASD/SSD è obbligatorio selezionare almeno un organismo per ogni sport.");
			setModalShowed(true);
			return;
		}
        
		let existing_sp = false;
		data_json.forEach(element => {
			if(element.type === selectedSport) {
				existing_sp = true;
			}
		});

		if(existing_sp && !editMode) {
			setModalTitle("Errore durante l'operazione");
			setModalText("Lo sport è già presente nella tua struttura.");
			setModalShowed(true);
			return;
		}

        let sports_send = [];
		data_json.forEach(element => {
			// Se siamo in modalità edit e questo è lo sport che stiamo modificando, saltalo (lo aggiungiamo dopo aggiornato)
			if (editMode && element.type === selectedSport) {
				return;
			}
			
			// Mantieni gli sport esistenti con le loro federazioni se presenti
			const existingSport = { "sportType": element.type };
			if(element.sportPromotionBody && element.sportPromotionBody.length > 0) {
				existingSport.sportPromotionBody = element.sportPromotionBody;
			}
			sports_send.push(existingSport);
		});
		
		// Crea l'oggetto sport con federazioni opzionali
		const newSport = { "sportType": selectedSport };
		if(selectedFederation && selectedFederation.length > 0) {
			newSport.sportPromotionBody = selectedFederation.map(fed => fed.value);
		}
		
		sports_send.push(newSport);
		
		// Reset campi e chiudi modal
		resetModalFields();
		setModalCentered(false);
		setEditMode(false);
		
		updateProfile(sports_send);
    };

	function updateProfile(sports_send) {

		const saveData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    let profile_send = JSON.parse(JSON.stringify(props.profile));
					profile_send.club.sports = sports_send;
                    delete profile_send.club.logo;
                    delete profile_send.club.pictures;
                    delete profile_send.club.invoiceDataSender;

					setLoadingShowed(true);
                    const saveResult = await apiClient.updateProfile(token, profile_send);
					setLoadingShowed(false);

                    if(saveResult && saveResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante il salvataggio ("+saveResult.error+")");
                        setModalShowed(true);
                    } else {
						window.location.href = '/struttura/lamiastruttura?tab=sport';
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        saveData();
	}

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">Sei sicuro di volere continuare?</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalCentered} centered>
				<Modal.Header>
					<Modal.Title>{editMode ? 'Modifica sport' : 'Aggiungi Sport'}</Modal.Title>
					<Button
						onClick={() => {
							resetModalFields();
							setModalCentered(false);
							setEditMode(false);
						}}
						variant=""
						className="btn-close"
					>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Row>
							<Col className="col-lg-12 pb-4">
								<Form.Label>Seleziona sport</Form.Label>
								{editMode
									? <Form.Control disabled value={sports.find((o) => o.value === selectedSport)?.label || ''} />
									: (
										<CampoRicerca
											id="campo-sport"
											opzioni={sports}
											valore={selectedSport}
											onChange={(v) => handleSelectChange({ value: v })}
											minCaratteri={2}
											massimo={10}
										/>
									)}
							</Col>
							{selectedSport && (props.profile?.club?.clubNature === 'ASD' || props.profile?.club?.clubNature === 'SSD') && (
								<Col className="col-lg-12 pb-4">
									<Form.Label>Seleziona organismo *</Form.Label>
									{federationsLoading ? (
										<div>Caricamento organismi...</div>
									) : federationsError ? (
										<div style={{color: 'red'}}>Errore nel caricamento degli organismi</div>
									) : (
										<Select
							name="federation"
							value={selectedFederation}
							onChange={handleFederationChange}
							options={getAvailableFederations()}
							placeholder="Seleziona almeno un organismo..."
							isMulti={true}
							isClearable={true}
							style={{
								lineHeight: "40px",
								color: "#fd7e14",
								paddingLeft: " 15px",
							}}
						/>
									)}
								</Col>
							)}
						</Row>
					</Form>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
							<Button
								className="btn btn-light btn-add"
								onClick={() => {
									resetModalFields();
									setModalCentered(false);
									setEditMode(false);
								}}>
								Annulla
							</Button>
							<Button onClick={addSports} className="btn btn-primary btn-add">
								{editMode ? 'Salva modifiche' : 'Aggiungi'}
							</Button>
						</Modal.Footer>
			</Modal>

			{data_json && data_json.length === 0 &&
				<center>
					<div>
						<img src={nosports} style={{width: '50%'}} alt="" />
					</div>
					<div style={{ fontSize: '26px', color: 'grey', marginTop: '30px'}}>
						Nessuno sport inserito
					</div>
					<div style={{ fontSize: '16px', color: 'grey', fontWeight: '300', marginTop: '20px'}}>
						Non hai ancora inserito nessuno sport
						<br></br>
						Inizia adesso e aggiungi il tuo primo sport per vedere il dettaglio qui.
					</div>
					<div>
						{!props.isDisabled && <Button style={{ marginTop: '20px'}} onClick={() => setModalCentered(true)} className="btn btn-primary btn-sm btn-add" ><Add variant="Bulk" /><span className='ms-2'>Aggiungi</span></Button>}
					</div>
				</center>
			}

			{data_json && data_json.length>0 &&
				<TabellaLista
					openColumn={'sport_name'}
					openRow={props.isDisabled ? undefined : (row) => openEditModal(row)}
					cardTitle={'Lista Sport'}
					hasSearch={false}
					hasFilter={false}
					data_column={data_column}
					data_json={data_json}
					hasAddMoreAsModal={props.isDisabled ? false : true}
					modalCallBack={() => {
						setEditMode(false);
						resetModalFields();
						setModalCentered(true);
					}}
				/>
			}
		</>
	)
}
export default FormSport;